import ApiBase from 'app/services/api/entities/Base'

/**
 * Politica de capacitacion del asesor (R26-865).
 *
 * El dashboard (`/me/`) responde TODO lo que la pantalla necesita en una
 * sola llamada: etapa, estado, Universidad, horas, facturacion, inventario y
 * proxima evaluacion. El servidor es el dueno de esos numeros — aqui no se
 * recalcula ninguno, porque son exactamente los que se usaron (o se usaran)
 * para evaluar al asesor.
 */
function* me(requestOptions) {
  return yield ApiBase.privateGet('/v1/training-policy/me/', requestOptions)
}

/** Historial de veredictos aplicados (los de sombra nunca se exponen). */
function* evaluations(requestOptions) {
  return yield ApiBase.privateGet(
    '/v1/training-policy/me/evaluations/',
    requestOptions
  )
}

function* trainings(params, requestOptions) {
  return yield ApiBase.privateGet('/v1/training-policy/trainings/', {
    ...requestOptions,
    params,
  })
}

/**
 * Formulario prefirmado para subir la constancia DIRECTO a S3.
 *
 * El archivo nunca pasa por la API: el proyecto no configura almacenamiento
 * de medios, asi que un upload por multipart terminaria en el disco efimero
 * del pod. Mismo patron que la subida de Dokaltin.
 */
function* requestEvidenceUpload(requestOptions) {
  return yield ApiBase.privatePost(
    '/v1/training-policy/trainings/evidence-upload/',
    requestOptions
  )
}

/**
 * Alta de una capacitacion externa. Lleva la LLAVE del objeto ya subido a S3,
 * no el archivo. Las horas NO suman hasta que un administrador la aprueba.
 */
function* createTraining(data, requestOptions) {
  return yield ApiBase.privatePost('/v1/training-policy/trainings/', {
    ...requestOptions,
    data,
  })
}

export default {
  me,
  evaluations,
  trainings,
  requestEvidenceUpload,
  createTraining,
}
